export const FETCH_CREDIT_USAGE_DETAILS = 'src/Corporate/usage-stats/action/FETCH_CREDIT_USAGE_DETAILS';
export const FETCH_CREDIT_USAGE_SUCCESS = 'src/Corporate/usage-stats/action/FETCH_CREDIT_USAGE_SUCCESS';
export const FETCH_CREDIT_USAGE_FAILURE = 'src/Corporate/usage-stats/action/FETCH_CREDIT_USAGE_FAILURE';
export const fetchCreditUsageData = (data) => {
    return {
        type: FETCH_CREDIT_USAGE_DETAILS,
        data
    }
}
export const fetchCreditUsageDataSuccess = (data) => {
    return {
        type: FETCH_CREDIT_USAGE_SUCCESS,
        data
    }
}
export const fetchCreditUsageDataFailure = (data) => {
    return {
        type: FETCH_CREDIT_USAGE_FAILURE,
        data
    }
}

export const FETCH_CREDIT_USAGE_GRAPH_TILE_DETAILS = 'src/Corporate/usage-stats/action/FETCH_CREDIT_USAGE_GRAPH_TILE_DETAILS';
export const FETCH_CREDIT_USAGE_GRAPH_TILE_SUCCESS = 'src/Corporate/usage-stats/action/FETCH_CREDIT_USAGE_GRAPH_TILE_SUCCESS';
export const FETCH_CREDIT_USAGE_GRAPH_TILE_FAILURE = 'src/Corporate/usage-stats/action/FETCH_CREDIT_USAGE_GRAPH_TILE_FAILURE';
export const fetchCreditUsageGraphTileData = () => {
    return {
        type: FETCH_CREDIT_USAGE_GRAPH_TILE_DETAILS,
    }
}
export const fetchCreditUsageGraphTileDataSuccess = (data) => {
    return {
        type: FETCH_CREDIT_USAGE_GRAPH_TILE_SUCCESS,
        data
    }
}
export const fetchCreditUsageGraphTileDataFailure = (data) => {
    return {
        type: FETCH_CREDIT_USAGE_GRAPH_TILE_FAILURE,
        data
    }
}


export const DOWNLOAD_CREDIT_USAGE = 'src/Corporate/usage-stats/action/DOWNLOAD_CREDIT_USAGE';
export const DOWNLOAD_CREDIT_USAGE_SUCCESS = 'src/Corporate/usage-stats/action/DOWNLOAD_CREDIT_USAGE_SUCCESS';
export const DOWNLOAD_CREDIT_USAGE_FAILURE = 'src/Corporate/usage-stats/action/DOWNLOAD_CREDIT_USAGE_FAILURE';
export const downloadCreditUsageData = (data) => {
    return {
        type: DOWNLOAD_CREDIT_USAGE,
        data
    }
}
export const downloadCreditUsageDataSuccess = (data) => {
    return {
        type: DOWNLOAD_CREDIT_USAGE_SUCCESS,
        data
    }
}
export const downloadCreditUsageDataFailure = (data) => {
    return {
        type: DOWNLOAD_CREDIT_USAGE_FAILURE,
        data
    }
}

export const FETCH_PRODUCT_NAME = 'src/Corporate/usage-stats/action/FETCH_PRODUCT_NAME';
export const FETCH_PRODUCT_NAME_SUCCESS = 'src/Corporate/usage-stats/action/FETCH_PRODUCT_NAME_SUCCESS';
export const FETCH_PRODUCT_NAME_FAILURE = 'src/Corporate/usage-stats/action/FETCH_PRODUCT_NAME_FAILURE';
export const fetchProductNameData = () => {
    return {
        type: FETCH_PRODUCT_NAME,
    }
}
export const fetchProductNameDataSuccess = (data) => {
    return {
        type: FETCH_PRODUCT_NAME_SUCCESS,
        data
    }
}
export const fetchProductNameDataFailure = (data) => {
    return {
        type: FETCH_PRODUCT_NAME_FAILURE,
        data
    }
}